<template>
    <div class="select_dialog_embed">
      <div class="index_embed_msg">
        <div class="select_dialog_embed_box">
          <!--弹出框头部-->
          <div class="select_dialog_embed_box_top">
            <p>{{title}}</p>
          </div>

          <!--弹出框信息-->
          <div class="select_dialog_embed_box_content">
            <div class="select_dialog_embed_box_handle">
              <input type="password" v-model.trim="paymentPassword" placeholder="请输入支付密码">
            </div>
          </div>

          <!--弹出框底部-->
          <div class="select_dialog_embed_box_bottom">
            <button class="btn_normal" @click="changeAgentAutoPayStatus()">提交</button>
            <button class="btn_cancel" @click="cancelBtn(false)">取消</button>
          </div>
        </div>

        <!--信息提示框-->
        <msg-dialog v-if="isMsg"
                    :txt="txtMsg"
                    :is-suc="isSuc"
                    @closebtn="closeMsgDialog"></msg-dialog>
      </div>
    </div>
</template>

<script type="es6">
  import MsgDialog from '../public-component/msg-dialog';

  export default {
    name: 'index-embed-msg',
    components: {MsgDialog},
    props: ['title', 'msg'],
    data() {
      return {
        paymentPassword: '', // 支付密码
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '' // 信息框内容
      }
    },
    methods: {
      // 更改分销商自动付款状态
      changeAgentAutoPayStatus() {
        if (!this.paymentPassword) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入支付密码';
          return;
        }
        const params = {
          payPwd: this.paymentPassword,
          autoPayStatus: this.msg
        };
        this.$axios.post(this.Global.changeAgentAutoPayStatus, params).then((res) => {
          if (!res.data.errorMsg.length) {
            this.isMsg = true;
            this.isSuc = true;
            this.txtMsg = '操作成功';
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 取消按钮
      cancelBtn(type) {
        this.$emit('cancelbtn', {isShow: false, handleType: type});
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
        if (this.isSuc) {
          this.cancelBtn(true);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/home-view";

  .index_embed_msg {
    background-color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/index-embed-msg.vue